import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  wrap: {
    position: "absolute",
    inset: 0,
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "28px 36px",
    gap: 12,
  },
  kicker: {
    alignSelf: "flex-start",
    margin: 0,
    padding: "6px 12px",
    borderRadius: 999,
    background: "rgba(255,255,255,0.72)",
    border: "1px solid rgba(15,23,42,0.08)",
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "#334155",
  },
  title: {
    margin: 0,
    maxWidth: 460,
    fontSize: 28,
    lineHeight: 1.15,
    fontWeight: 900,
    letterSpacing: -0.6,
    color: "#0f172a",
  },
  lead: {
    margin: 0,
    maxWidth: 460,
    color: "#475569",
    fontSize: 15,
    lineHeight: 1.5,
  },
  list: {
    margin: "6px 0 0",
    padding: 0,
    listStyle: "none",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
  },
  card: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    padding: "12px 12px 10px",
    borderRadius: 16,
    background: "rgba(255,255,255,0.82)",
    border: "1px solid rgba(15,23,42,0.08)",
    boxShadow: "0 10px 28px rgba(15,23,42,0.08)",
  },
  emoji: {
    fontSize: 22,
    lineHeight: 1,
  },
  name: {
    margin: 0,
    fontSize: 14,
    fontWeight: 800,
    color: "#0f172a",
  },
  desc: {
    margin: "4px 0 0",
    fontSize: 12,
    lineHeight: 1.4,
    color: "#64748b",
  },
}));

const FEATURES = [
  { emoji: "💬", name: "WhatsApp", desc: "Varios agentes atienden el mismo número." },
  { emoji: "✈️", name: "Telegram", desc: "Bot, grupos y campañas en el mismo panel." },
  { emoji: "🤖", name: "Agente", desc: "Responde, cotiza y entrega en el chat." },
  { emoji: "🛍️", name: "Tienda", desc: "Catálogo, pagos y cuentas en un solo lugar." },
  { emoji: "📣", name: "Campañas", desc: "Mensajes, grupos y estados en los dos canales.", wide: true },
];

const AuthShowcase = () => {
  const classes = useStyles();
  return (
    <div className={classes.wrap}>
      <p className={classes.kicker}>Panel</p>
      <h2 className={classes.title}>WhatsApp y Telegram, en un solo lugar</h2>
      <p className={classes.lead}>
        Atiende, vende y automatiza en los dos canales.
      </p>
      <ul className={classes.list}>
        {FEATURES.map((item) => (
          <li key={item.name} className={classes.card} style={item.wide ? { gridColumn: "1 / -1" } : undefined}>
            <span className={classes.emoji} aria-hidden="true">{item.emoji}</span>
            <div>
              <p className={classes.name}>{item.name}</p>
              <p className={classes.desc}>{item.desc}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AuthShowcase;
